import { useQuery } from '@tanstack/react-query';
import { DailyDesignProgressSummaryRequestDto } from 'src/api/FiretrolApiClient';
import { dailyApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export type DailyDesignProgressTarget = Omit<
  DailyDesignProgressSummaryRequestDto,
  'jobId'
>;

/** @registry Installed Progress viewer quantities per WBS account, for a daily (by dailyId), for progress items saved from the daily form (by progressItemIds), or both. */
export function useDailyDesignProgressSummary(
  jobId: number | null | undefined,
  target: DailyDesignProgressTarget,
) {
  const hasTarget =
    !!target.dailyId || (target.progressItemIds?.length ?? 0) > 0;
  return useQuery({
    queryKey: queryKeys.dailys.designProgressSummary(jobId ?? -1, target),
    queryFn: ({ signal }) =>
      dailyApiClient.summarizeDesignProgress(
        { ...target, jobId: jobId! },
        toCancelToken(signal),
      ),
    enabled: jobId != null && hasTarget,
    staleTime: 0,
    meta: { errorContext: 'daily design progress' },
  });
}
